export const CRUMB_LABEL_KEY = 'PendingRequest';
export const NAME = 'PendingRequestListIframe';
